export default __webpack_public_path__ + "static/media/srisailamVisitThirteen.15768dc3.jpg";